// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ns-email[data-v-2e0411b6]{position:relative}.theme--light.v-input:not(.v-input--is-disabled) input[data-v-2e0411b6]{border:1px solid #252525}", ""]);
// Exports
module.exports = exports;
